import React from "react";
import { PageHero } from "@/components/common/Bits";
import { useLanguage } from "@/context/LanguageContext";

function LegalTemplate({ overline, title, intro, sections }) {
  const { t } = useLanguage();
  return (
    <div data-testid={`legal-${overline}`}>
      <PageHero overline={t.legal} title={title} description={intro}/>
      <section className="useko-container max-w-3xl py-16">
        <div className="prose-useko">
          {sections.map((s, i) => (
            <div key={i}>
              <h2>{s.heading}</h2>
              {s.body.split("\n").map((p, j) => <p key={j}>{p}</p>)}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export function KvkkPage() {
  const { t } = useLanguage();
  return <LegalTemplate overline="kvkk" title={t.kvkk} intro={t.legal_kvkk_intro} sections={[
    { heading: "Veri Sorumlusu", body: "USEKO — Uluslararası Sürdürülebilir Kalkınma Ekonomik İşbirliği ve Organizasyon Derneği bu metin kapsamında veri sorumlusu sıfatıyla hareket etmektedir." },
    { heading: "Kişisel Verilerin İşlenme Amacı", body: "Üyelik, gönüllülük ve iş birliği başvurularınızın değerlendirilmesi, sizinle iletişim kurulması ve yasal yükümlülüklerin yerine getirilmesi amaçlarıyla işlenmektedir." },
    { heading: "Aktarım", body: "Kişisel verileriniz, açık rızanız olmadıkça üçüncü kişilerle paylaşılmamaktadır. Yasal zorunluluklar saklıdır." },
    { heading: "Haklarınız", body: "KVKK kapsamında; verilerinize erişme, düzeltme, silme, işlenmesine itiraz etme ve şikâyet hakkına sahipsiniz. Talepleriniz için info@useko.org adresine yazabilirsiniz." },
  ]}/>;
}

export function PrivacyPage() {
  const { t } = useLanguage();
  return <LegalTemplate overline="privacy" title={t.privacy} intro={t.legal_privacy_intro} sections={[
    { heading: "Toplanan Bilgiler", body: "Formlar üzerinden gönüllü olarak paylaştığınız iletişim bilgileri, açıklamalar ve başvuru detayları toplanır." },
    { heading: "Kullanım Amacı", body: "Bilgiler yalnızca başvuru değerlendirme, iletişim ve raporlama süreçlerinde kullanılır." },
    { heading: "Güvenlik", body: "Verileriniz güvenli sunucularda tutulur ve yetkisiz erişime karşı korunur." },
  ]}/>;
}

export function CookiesPage() {
  const { t } = useLanguage();
  return <LegalTemplate overline="cookies" title={t.cookies} intro={t.legal_cookies_intro} sections={[
    { heading: "Çerez Türleri", body: "Sitemizde zorunlu çerezler, analitik çerezler ve pazarlama çerezleri kullanılmaktadır." },
    { heading: "Tercih Yönetimi", body: "Çerez tercihlerinizi sitedeki çerez banner'ı üzerinden dilediğiniz zaman güncelleyebilirsiniz." },
  ]}/>;
}

export function TermsPage() {
  const { t } = useLanguage();
  return <LegalTemplate overline="terms" title={t.terms} intro={t.legal_terms_intro} sections={[
    { heading: "Fikri Mülkiyet", body: "Sitedeki tüm içerik USEKO'ya aittir ve izinsiz kopyalanamaz." },
    { heading: "Sorumluluk", body: "USEKO, site kullanımından kaynaklanabilecek dolaylı zararlardan sorumlu tutulamaz." },
  ]}/>;
}

export function NotFoundPage() {
  const { t } = useLanguage();
  return (
    <div className="useko-container py-32 text-center" data-testid="page-404">
      <div className="overline mb-3">404</div>
      <h1 className="font-heading text-4xl md:text-5xl font-bold text-[#102A43]">{t.not_found_title}</h1>
      <p className="mt-4 text-[#4B5563]">{t.not_found_body || ""}</p>
      <a href="/" className="btn-primary mt-8 inline-flex">{t.back_to_home}</a>
    </div>
  );
}
